import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation} from "@angular/core";
import {FormControl} from "@angular/forms";
import {SpinnerService} from "../../../../../../../../common/services/spinner.service";
import {Api, ApiService} from "../../../../../../../../common/services/api.service";
import {ToastService} from "../../../../../../../../common/services/toast.service";
import {ModalService} from "../../../../../../../services/modal.service";
import {UserService} from "../../../../../../../../common/services/user.service";
import {StorageService} from "../../../../../../../../common/services/storage.service";
import {HelpersService} from "../../../../../../../../common/services/helpers.service";
import {Api3Service} from "../../../../../../../../common/services/api3.service";
import {PartMasterService} from "src/modules/common/services/part-master.service";
import {OrderWizardItemRmaComponent} from "../rma/item.component";


@Component({
    selector: "section-order-wizard-item-kitting",
    templateUrl: "../../../item/item.component.html",
    styleUrls: [
        "../../../item/item.component.scss"
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class OrderWizardItemKittingComponent extends OrderWizardItemRmaComponent implements OnInit {

    public constructor(
        protected changeDetectorRef: ChangeDetectorRef,
        protected apiService: ApiService,
        protected api3Service: Api3Service,
        protected toastService: ToastService,
        protected modalService: ModalService,
        protected userService: UserService,
        protected storageService: StorageService,
        protected spinnerService: SpinnerService,
        protected helpersService: HelpersService,
        protected partMasterService: PartMasterService,
    ) {
        super(changeDetectorRef, apiService, api3Service, toastService, modalService, userService, storageService,
            spinnerService, helpersService, partMasterService);
    }

    protected getOutboundHubs(): void {
        // if (this.outboundHubRef) {
        //     this.outboundHubRef.getHubs();
        // }
    }

    protected getInboundHubs(): void {
        // if (this.inboundHubRef) {
        //     this.inboundHubRef.getHubs();
        // }
    }


    public onItemSelected($event: any): void {
        super.onItemSelected($event);

        if (!this.manualType) {
            this.getInboundHubs();
            this.getOutboundHubs();
        } else if (this.itemType === "outbound") {
            this.getOutboundHubs();
        } else if (this.itemType === "inbound") {
            this.getInboundHubs();
        }
    }

    public showOutboundHubSelect(): boolean {
        return this.itemType === "outbound";

    }

    public showInboundHubSelect(): boolean {
        return this.itemType === "inbound";

    }

    /**
     * Add item (prepare & add modal response)
     */
    public async save(): Promise<any> {

        this.spinnerService.show();

        const items: any[] = [];

        items.push({
            ...this.formGroup.value,
            hub_id: this.formGroup.value[this.itemType + "_hub_id"],
            order_id: this.modal.params.order_id,
            type: this.itemType
        });


        const {code, message}: Api.IResponse = await this.api3Service.post(
            `${this.modal.params.state.section}/order-items`, {items});

        this.spinnerService.hide();

        this.modal.response.next({
            name: "value",
            value: true
        });

        if (code === 200) {
            this.toastService.show(message, "success");
        }
    }


    public ngOnInit(): void {
        if (this.modal.params.type) {
            this.itemType = this.modal.params.type;
        }

        this.manualType = true;

        this.options.hubs_from = this.modal.params.hubs_from;
        this.options.hubs_to = this.modal.params.hubs_to;

        this.formGroup.addControl("type", new FormControl(this.itemType));

        this.setValidators(this.manualType);

        this.changeDetectorRef.markForCheck();

        super.ngOnInit();
    }
}
